<template>
  <v-card
    class="w-50 py-8 px-6 text-center"
    elevation="0">
    <v-card-title> ワンタイムパスワード認証（利用登録） </v-card-title>

    <v-alert
      type="info"
      variant="tonal"
      class="mb-8 text-left">
      初回認証時はワンタイムパスワードの利用登録が必要となります。<br />
      Google AuthenticatorでQRコードを読み取り、ワンタイムパスワードを入力してください。
    </v-alert>

    <!-- エラーメッセージ -->
    <v-alert
      v-if="props.error"
      type="error"
      variant="tonal"
      class="mb-8 text-left">
      {{ props.error }}
    </v-alert>

    <img
      id="qrcode"
      :src="qrData" />

    <v-form @submit.prevent="submit">
      <v-otp-input
        v-model="totp"
        variant="outlined"
        length="6"></v-otp-input>

      <v-btn
        :loading="loading"
        :disabled="!sendable"
        type="submit"
        class="my-4"
        width="70%"
        variant="flat"
        color="primary"
        size="large">
        認証
      </v-btn>
    </v-form>
  </v-card>
</template>

<script setup lang="ts">
import QRCode from 'qrcode';
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
  url: String,
  loading: Boolean,
  error: String
});

const emit = defineEmits<{
  submit: [password: string];
}>();

let totp = ref('');
let qrData = ref('');

let sendable = computed(() => {
  return totp.value.length === 6;
});

let loading = false;

onMounted(async () => {
  // QRコード生成
  qrData.value = await QRCode.toDataURL(props.url);
});

function submit() {
  loading = true;
  emit('submit', totp.value);
  loading = false;
}
</script>
